import { render, staticRenderFns } from "./expertSign.vue?vue&type=template&id=50706230&scoped=true"
import script from "./expertSign.vue?vue&type=script&lang=js"
export * from "./expertSign.vue?vue&type=script&lang=js"
import style0 from "./expertSign.vue?vue&type=style&index=0&id=50706230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50706230",
  null
  
)

export default component.exports